<template>
  <div
    class="text-center"
    :data-currency="currency"
    :data-price-symbol="priceF.symbol"
  >
    <div
      class="flex flex-col flex-wrap gap-1 lg:justify-start"
      data-el="price-inner"
    >
      <div class="font-sans text-5xl text-gray-800">
        <span class="flex items-start gap-0.5" v-if="notFree" data-price-value
          ><span class="font-thin text-gray-800">{{ priceF.symbol }}</span
          ><span class="font-medium">{{ dollars }}</span>
          <span
            class="text-sm font-normal text-gray-700"
            v-if="priceF.centsF"
            >{{ priceF.centsF }}</span
          >
        </span>
        <span class="text-uppercase" v-else data-price-value>{{ 'Free' }}</span>
      </div>
      <aside
        class="flex flex-row items-start gap-1 text-xs font-light text-gray-500"
      >
        <span>{{ 'Per Month' }}</span>
        <span v-if="billed">{{ billed }}</span>
      </aside>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  FormattedPrice,
  PlanDisplayCurrencyEnum,
  PlanDisplayScheduleEnum,
} from '@mailslurp/admin-sdk';
import { PlanDisplaysSchedulesEnum } from '@mailslurp/admin-sdk';
import { computed } from 'vue';

const props = defineProps<{
  schedule: PlanDisplaysSchedulesEnum | PlanDisplayScheduleEnum;
  priceF: FormattedPrice;
  currency: PlanDisplayCurrencyEnum;
}>();
const notFree = computed(() => {
  return (props.priceF.cost || 0) > 0;
});

const billed = computed(() => {
  return props.schedule === PlanDisplaysSchedulesEnum.YEARLY
    ? 'Billed annually'
    : null;
});

const dollars = computed(() => {
  return props.priceF?.dollars?.toLocaleString() ?? props.priceF?.dollarsF;
});
</script>
